import { RootState } from 'store/types';
import { createSelector } from 'reselect';
import { Coordinate } from 'modules/types/common';
import { GeolocationPermissionsStatus } from 'store/geolocation/types';

export const geolocationSelector = (state: RootState) => state.geolocation;

export const geolocationCoordsSelector = createSelector(
  geolocationSelector,
  geo => geo.coords as Coordinate
);

export const geolocationTimestampSelector = createSelector(
  geolocationSelector,
  geo => geo.timestamp
);

export const geolocationAcceptedSelector = createSelector(
  geolocationSelector,
  geo => geo.status === GeolocationPermissionsStatus.ACCEPTED
);

export const geolocationDeniedSelector = createSelector(
  geolocationSelector,
  geo => geo.status === GeolocationPermissionsStatus.DENIED
);

export const geolocationRequestedSelector = createSelector(
  geolocationSelector,
  geo => geo.status !== GeolocationPermissionsStatus.UNKNOWN
);

export const geolocationErrorShownSelector = createSelector(
  geolocationSelector,
  geo => geo.errorShown
);
